import React from 'react';
class Main extends React.Component {
  render() {
    var cls = this.props.cls;
    return /*#__PURE__*/React.createElement("main", {
      className: cls
    }, this.props.children);
  }
}
export default Main;